export default "__VITE_ASSET__BVt0xwM3__"